import { useMemo, useSyncExternalStore } from 'react';
import { db } from '../utils/db';
import type { Tables } from '../types/db';

/** Read from the fake database; re-renders when the data changes. */
export function useDb<T>(selector: (t: Tables) => T, deps: unknown[] = []): T {
  const state = useSyncExternalStore(db.subscribe, db.getState, db.getState);
  // eslint-disable-next-line react-hooks/exhaustive-deps
  return useMemo(() => selector(state), [state, ...deps]);
}
